module.exports = __webpack_public_path__ + "static/img/oo.19818b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/oo.jpg
// module id = 5GkN
// module chunks = 0